import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  NgModule,
  Output,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare const window: any;

const defaultUtilScript = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.1/js/utils.js';

@Directive({
  selector: '[ng2TelInput]'
})
export class Ng2TelInput {
  @Input('ng2TelInputOptions') ng2TelInputOptions: any = {};
  @Output() hasError = new EventEmitter<boolean>();
  @Output() ng2TelOutput = new EventEmitter<string>();
  @Output() countryChange = new EventEmitter<any>();
  @Output() intlTelInputObject = new EventEmitter<any>();

  private ngTelInput: any;

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: string) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.ng2TelInputOptions = {
        ...this.ng2TelInputOptions,
        utilsScript: this.getUtilsScript(this.ng2TelInputOptions)
      };
      this.ngTelInput = window.intlTelInput(this.el.nativeElement, { ...this.ng2TelInputOptions });
      this.el.nativeElement.addEventListener('countrychange', () => {
        this.countryChange.emit(this.ngTelInput.getSelectedCountryData());
      });
      this.intlTelInputObject.emit(this.ngTelInput);
    }
  }

  @HostListener('blur')
  onBlur() {
    const isInputValid = this.isInputValid();
    if (isInputValid) {
      const telOutput = this.ngTelInput.getNumber();
      this.hasError.emit(isInputValid);
      this.ng2TelOutput.emit(telOutput);
    } else {
      this.hasError.emit(isInputValid);
    }
  }

  isInputValid(): boolean {
    return this.ngTelInput.isValidNumber();
  }

  setCountry(country: string) {
    this.ngTelInput.setCountry(country);
  }

  getUtilsScript(options: any): string {
    return options.utilsScript || defaultUtilScript;
  }
}

@NgModule({
  declarations: [Ng2TelInput],
  exports: [Ng2TelInput]
})
export class Ng2TelInputModule {
  static forRoot() {
    return {
      ngModule: Ng2TelInputModule,
      providers: []
    };
  }
}
